module.exports = __webpack_public_path__ + "static/merchant-campaign-promotional-76b02878152a7d76020f144668fa414a.png";